import { FunctionComponent } from "react";
import { IAvatarProps } from "./interfaces/IAvatarProps";
import "./styles/avatar.css";

export const Avatar: FunctionComponent<IAvatarProps> = (props) => {
    const alt = props.alt !== undefined ? props.alt : "";
    const className = `uui-avatar ${props.className !== undefined ? props.className : ""}`;

    return (
        <div className={className}>
            <img alt={alt} src={props.src} />
        </div>
    );
};
